import { Routes, Route, Navigate } from "react-router-dom";
import About from "./About";
// import Domestic from "./Domestic";


const aboutUsRoutes = [
    
    {routeName: 'mission' , component: <About/>},
    {routeName: 'mile-stone' , component: <About/>},
];

const AboutUsRoutes = () => {
    return (
    <Routes>
       {aboutUsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default AboutUsRoutes;